import api from '../../../api/consultations/_historique-consultation'

const state = () => ({
    consultation_historiques: [],
    liste_consultations_patient: [],
})

// getters
const getters = {
    consultation_historiques: (state) => {
        return state.consultation_historiques
    },

    liste_consultations_patient: (state) => {
        return state.liste_consultations_patient
    },
}

// mutations
const mutations = {
    SET_CONSULTATION_HISTORIQUES(state, liste) {
        state.consultation_historiques = liste
    },

    SET_LISTE_CONSULTATIONS_PATIENT(state, liste) {
        state.liste_consultations_patient = liste
    },
}

// actions
const actions = {
    getListeHistoriqueConsultation({commit}, data){
        return new Promise((resolve,reject) => {
            api.getListeHistoriqueConsultation(data).then(
                response => {
                    commit('SET_CONSULTATION_HISTORIQUES', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getListeConsultationsPatient({commit}, patient_id){
        return new Promise((resolve,reject) => {
            api.getListeConsultationsPatient(patient_id).then(
                response => {
                    commit('SET_LISTE_CONSULTATIONS_PATIENT', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}